import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import CzechAccountInput from "controls/finance/czechAccountInput";
import type BankAccountCreateViewModel from "viewModels/finance/bankAccounts/bankAccountCreateViewModel";
import type BankAccountDetailViewModel from "viewModels/finance/bankAccounts/bankAccountDetailViewModel";

export interface BankAccountFormProps {
  vm: BankAccountCreateViewModel | BankAccountDetailViewModel;
  children?: React.ReactNode;
}

const BankAccountForm = observer((props: BankAccountFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <Form.Group as={Col} md="12">
          <Form.Label>{vm.translateAttribute("bankAccount")}</Form.Label>
          <CzechAccountInput target={vm.item} property="bankAccount" disabled={disabled} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} md="6">
          <Form.Label>{vm.translateAttribute("currencyCode")}</Form.Label>
          <Input target={vm.item} property="currencyCode" disabled={disabled} />
        </Form.Group>
        <Form.Group as={Col} md="6">
          <Form.Label>{vm.translateAttribute("description")}</Form.Label>
          <Input target={vm.item} property="description" disabled={disabled} />
        </Form.Group>
      </Form.Row>
      {children}
    </>
  );
});

export default BankAccountForm;
